import _ from 'lodash'
import TextDivider from 'components/atoms/TextDivider'
import ThemedBlock from 'components/atoms/ThemedBlock'
import HelperString from 'utils/helper-string'
import { StyleSheet, View } from 'react-native'
import { ThemedValues } from 'styles/themed'
import LunchOption from 'scenes/home/book/lunch/_components/LunchOption'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectCartEmployees } from 'services/redux/cart/reducers'
import TimeslotDivider from 'components/atoms/TimeslotDivider'
import HelperDate from 'utils/helper-date'

const LunchBookings = ({ days, onSelect }) => {
	
	const _cartEmployees = useSelector( selectCartEmployees );
	
	const content = [];
	
	_.forEach( days, ( buildings, date ) => {
		_.forEach( buildings, building => {
			content.push(
				<TextDivider
					key={ HelperString.hash( 'day-building-divider', date ) }
					text={`${ _.capitalize( HelperDate.date( date ).format('dddd - D MMMM') ) } - ${ building.title }`}
				/>
			)
			
			content.push(
				<ThemedBlock
					key={ HelperString.hash( 'day-building', date ) }
					shadow>
					
					{ _.map( building.data, (booking) => {
						let optionNr = 0;
						
						return (
							<View
								key={ HelperString.hash( `choose-lunch-render-lunch-option-view-${date}`, booking ) }
								style={ staticStyles.viewMarginBottomMarginHorizontal }>
								
								{ _.map( _cartEmployees, (employee, key) => {
									optionNr++;
									
									return (
										<>
											<LunchOption
												item={ booking }
												employee={ employee }
												onSelect={ onSelect }
											/>
											
											{ optionNr < _.size( _cartEmployees ) && (
												<TimeslotDivider />
											)}
										</>
									)
								})}
							</View>
						)
					})}
				</ThemedBlock>
			)
		})
	})
	
	return content
}

const staticStyles = StyleSheet.create({
	viewMarginBottomMarginHorizontal: {
		marginBottom: ThemedValues.marginHorizontal,
	},
});

export default LunchBookings
